export const base_url = "https://multicook-be.vercel.app/"; //"http://localhost:8080/";

export const cloudinary_base_url =
  "https://res.cloudinary.com/dvloxectq/image/upload/";

export const storeId = "682b89f4c28a3e5c9c0ce408"; // default store ID

export const G_RECAPTCHA_SECRET = "6Lc4oRQpAAAAAJenhe32KyFrzjxkLVTkxKOkevcj"; // rename and reuse it when needed

export const viewportData = {
  desktop: {
    breakpoint: { max: 4000, min: 1280 },
    items: 3,
  },
  tablet: {
    breakpoint: { max: 1280, min: 880 },
    items: 2,
  },
  mobile: {
    breakpoint: { max: 880, min: 0 },
    items: 1,
  },
};

export const deliveryLinks = [
  {
    name: "UberEats",
    url: "https://www.ubereats.com/ca/store/multicook-brandon/ljo0TRsRUD-FQDigZ-luqA",
    img: "/images/Uber-Eats-logo.png",
    width: "w-20 md:w-24",
  },
  {
    name: "DoorDash",
    url: "https://www.doordash.com/store/multi-cook-handmade-frozen-food-brandon-34448517/70420749",
    img: "/images/DoorDash-logo.png",
    width: "w-28 md:w-36",
  },
  {
    name: "SkipTheDishes",
    url: "https://www.skipthedishes.com/multi-cook-brandon",
    img: "/images/skip-the-dishes-seeklogo.png",
    width: "w-8 md:w-12",
  },
];
